export const NotFound = () => {
  return (
    <div style={{ display: 'flex', 'justify-content': 'center', 'align-items': 'center', height: '60vh' }}>
      开发中 ...
    </div>
  );
};
